import $ from 'jquery';

$(function() {
    let map;
    let directionsService;
    let directionsRenderer;
    const snazzyStyle = require('./snazzy.json');

    // console.log(snazzyStyle);
    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

        directionsService = new google.maps.DirectionsService();
        directionsRenderer = new google.maps.DirectionsRenderer();

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            styles      : snazzyStyle,
        };
        let map = new google.maps.Map( $el[0], mapArgs );

        directionsRenderer.setMap(map);

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            term_id: $marker.data('term_id'),
            parent_id: $marker.data('parent_id'),
            slug: $marker.data('slug') ? $marker.data('slug') : 'alpine-park',
            //icon: $(`.js-ammenity-type[data-id=${$marker.data('term_id')}]`).data('icon'),
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
                calculateAndDisplayRoute( marker);
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    function calculateAndDisplayRoute(destination) {
        if(map.markers[0] != destination) {
            directionsService.route(
                {
                  origin: map.markers[0].position, // always hardcoded to Alpine Park
                  destination: destination.position,
                  travelMode: google.maps.TravelMode.DRIVING,
                },
                (response, status) => {
                  if (status === "OK") {
                    directionsRenderer.setOptions({suppressMarkers: true});
                    directionsRenderer.setDirections(response);
                  } else {
                    window.alert("Directions request failed due to " + status);
                  }
                }
            );
        }

      }



    // Render maps on page load.
    $(function(){
        $('.nearby-location-map').each(function(){
            map = initMap( $(this) );
            //console.log('test',$('.marker').eq(0));
            // calculateAndDisplayRoute( map.markers[2]);
        });

        $(document).on('click', '.nearby-location', function(e) {
            e.preventDefault();
            $('.nearby-location').removeClass('nearby-location--open');
            $(this).addClass('nearby-location--open');

            const locationSlug = $(this).data('slug');
            // find the marker and click on it.
            map.markers.forEach(function( marker ){
                if(marker.slug == locationSlug) {
                    calculateAndDisplayRoute(marker);
                }
            });
        })
    });

});